import { Component } from '@angular/core';
import { BaseErrorPageComponent } from '../base-error-page.component';

@Component({
    selector: 'app-bad-request-page',
    templateUrl: './bad-request-page.component.html',
    styleUrl: '../../../shared-styles/error-page.scss'
})
export class BadRequestPageComponent extends BaseErrorPageComponent {
}
